module.exports = __webpack_public_path__ + "static/media/RoomImage.d28ec059.jpg";